export const fieldNameNotificationsSection = <const>{
    newRequests: 'sendNewRequestsNotifications',
    comments: 'sendCommentsNotifications',
    workflow: 'sendWorkflowNotifications',
    other: 'sendApprovalChangeNotifications',
    summary: 'sendSummaryNotifications',
    summaryDay: 'summaryNotificationsSentOnDays',
    summaryTime: 'summaryNotificationsSentAtTime',
};
